"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
export const useScrollDirection = (t0, t1) => {
  const $ = _c(7);
  const enabled = t0 === undefined ? true : t0;
  const headerHeight = t1 === undefined ? 92 : t1;
  const [scrollDir, setScrollDir] = useState("up");
  const scrollDirRef = useRef(scrollDir);
  let t2;
  let t3;
  if ($[0] !== scrollDir) {
    t2 = () => {
      scrollDirRef.current = scrollDir;
    };
    t3 = [scrollDir];
    $[0] = scrollDir;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[3] !== enabled || $[4] !== headerHeight) {
    t4 = () => {
      if (!enabled) {
        return;
      }
      let lastScrollY = window.pageYOffset;
      const onScroll = () => {
        const y = window.pageYOffset;
        const currentDir = scrollDirRef.current;
        if (y <= headerHeight) {
          if (currentDir !== "up") {
            setScrollDir("up");
          }
          lastScrollY = y > 0 ? y : 0;
          return;
        }
        const dir = y > lastScrollY ? "down" : "up";
        if (y - lastScrollY > 5 && dir !== currentDir || lastScrollY - y > 5 && dir !== currentDir) {
          setScrollDir(dir);
        }
        lastScrollY = y > 0 ? y : 0;
      };
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", onScroll);
    };
    t5 = [enabled, headerHeight];
    $[3] = enabled;
    $[4] = headerHeight;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  return scrollDir;
};